<template>
  <div class="statistics _pb-16 _bg-white">
    <!-- <div
      class="statistics-main__title _py-16 _py-sm-8 _fs-48 _lh-64 _fw-700 _fs-sm-32 _lh-sm-38 _bg-light _bg-md-white _px-md-4 _mb-6"
    >
      <div class="container">{{ $t('cabinet.title') }}</div>
    </div> -->
    <div
      class="container"
      v-if="getStatistic && Object.keys(getStatistic).length"
    >
      <!-- <AppBtnBreadCrumb class="_mb-12 _mt-16 _my-sm-12 _ml-md-4" /> -->
      <div class="statistics__info-bottom">
        <div class="container _px-md-4">
          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('statistic.title') }}
          </h2>
          <div class="statistics__progress-all _py-6 _px-8 _px-sm-6">
            <div class="progress-all__item">
              <div
                class="progress-all__title _fw-400 _fs-sm-16 _fs-20 _lh-26 _tc-dark-grey _mb-4"
              >
                {{ $t('statistic.title') }}
              </div>
              <div class="inner-container">
                <Progress :value="allProgress || 0" :total="100">
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress-all__text">
                  <div
                    class="progress-all__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _pl-4"
                  >
                    {{ $t('statistic.complete') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('statistic.intensive') }}
          </h2>
          <div class="statistics__info-row _mb-16">
            <div
              class="statistics__progress _py-6 _px-8 _px-sm-6"
              v-for="(item, ind) in getIntensiveTotalProgress"
              :key="ind"
            >
              <div class="progress__item">
                <Progress
                  :value="Math.round(item.progress_percent)"
                  :total="100"
                  class="_mr-4"
                >
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                    v-html="getTranslate(item).title"
                  ></div>
                  <div class="btns-block">
                    <AppBtn
                      v-if="Math.round(item.progress_percent) < 100"
                      @click.native="
                        dataLayerPush(
                          getTranslate(item).title,
                          helpers.buildRoute({
                            name: 'Intensive',
                            params: { slug: item.slug, filtered: true },
                          })
                        )
                      "
                      class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                      :btnClass="'btn_primary'"
                    >
                      <div class="_tc-white">
                        <span class="_fs-16 _fw-500">{{
                          Math.round(item.progress_percent) > 0
                            ? $t('statistic.continue')
                            : $t('statistic.start')
                        }}</span>
                      </div>
                    </AppBtn>
                    <AppBtn
                      class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                      :btnClass="'btn_secondary'"
                      :disabled="Math.round(item.progress_percent) !== 100"
                      @click.native="showCertModal(true, item)"
                    >
                      <span class="_fs-16 _fw-500">{{
                        $t('modals.certificate.download')
                      }}</span>
                    </AppBtn>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('cabinet.dashboard.sections[3].title[0]') }}
          </h2>
          <div class="statistics__info-row _mb-16">
            <div
              class="statistics__progress _py-6 _px-8 _px-sm-6"
              v-if="
                successAcademyProgress.all &&
                Object.keys(successAcademyProgress.all).length
              "
            >
              <div class="progress__item">
                <Progress
                  :value="
                    Math.floor(
                      ((successAcademyProgress.all.viewed || 0) /
                        (successAcademyProgress.all.total || 1)) *
                        100
                    )
                  "
                  :total="100"
                  class="_mr-4"
                >
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                    v-html="$t('cabinet.dashboard.sections[3].title[0]')"
                  ></div>
                  <div class="btns-block">
                    <AppBtn
                      class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                      :btnClass="'btn_secondary'"
                      :disabled="
                        Math.floor(
                          ((successAcademyProgress.all.viewed || 0) /
                            (successAcademyProgress.all.total || 1)) *
                            100
                        ) !== 100
                      "
                      @click.native="showCertModal(true, certData)"
                    >
                      <span class="_fs-16 _fw-500">{{
                        $t('modals.certificate.download')
                      }}</span>
                    </AppBtn>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="statistics__progress _py-6 _px-8 _px-sm-6"
              v-for="(item, ind) in successAcademyProgress.sections"
              :key="100 + ind"
            >
              <div class="progress__item">
                <Progress
                  :value="
                    Math.floor(
                      (((item.section ? item.section.viewed : item.viewed) ||
                        0) /
                        (item.section
                          ? item.section.total || 1
                          : item.total || 1)) *
                        100
                    )
                  "
                  :total="100"
                  class="_mr-4"
                >
                  <template v-slot:progress="props">
                    <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                      props.progress.value
                    }}</span>
                    <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                      /{{ props.progress.total }}</span
                    >
                  </template>
                </Progress>
                <div class="progress__text">
                  <div
                    class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                    v-html="item.title"
                  ></div>
                  <div class="btns-block">
                    <AppBtn
                      v-if="
                        Math.floor(
                          (((item.section
                            ? item.section.viewed
                            : item.viewed) || 0) /
                            (item.section ? item.section.total : item.total)) *
                            100
                        ) < 100
                      "
                      @click.native="
                        dataLayerPush(item.title, {
                          name: 'SuccessAcademySections',
                          params: {
                            slug: ind,
                            filtered: true,
                          },
                        })
                      "
                      class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                      :btnClass="'btn_primary'"
                    >
                      <div class="_tc-white">
                        <span class="_fs-16 _fw-500">{{
                          Math.floor(
                            (((item.section
                              ? item.section.viewed
                              : item.viewed) || 0) /
                              (item.section
                                ? item.section.total
                                : item.total)) *
                              100
                          ) > 0
                            ? $t('statistic.continue')
                            : $t('statistic.start')
                        }}</span>
                      </div>
                    </AppBtn>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('cabinet.dashboard.sections[3].title[1]') }}
          </h2>

          <div class="statistics__progress-all _py-6 _px-8 _px-sm-6">
            <div class="progress__item">
              <Progress
                :value="
                  Math.floor(
                    ((getStatistic.grow.viewed || 0) /
                      getStatistic.grow.total) *
                      100
                  )
                "
                :total="100"
                class="_mr-4"
              >
                <template v-slot:progress="props">
                  <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                    props.progress.value
                  }}</span>
                  <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                    /{{ props.progress.total }}</span
                  >
                </template>
              </Progress>
              <div class="progress__text">
                <div
                  class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                  v-html="$t('cabinet.dashboard.sections[3].title[1]')"
                ></div>
                <div class="btns-block">
                  <AppBtn
                    v-if="
                      Math.floor(
                        ((getStatistic.grow.viewed || 0) /
                          getStatistic.grow.total) *
                          100
                      ) < 100
                    "
                    @click.native="
                      dataLayerPush('Общий прогресс по HN Grow', {
                        name: 'HNGrow',
                        params: {
                          filtered: true,
                        },
                      })
                    "
                    class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                    :btnClass="'btn_primary'"
                  >
                    <div class="_tc-white">
                      <span class="_fs-16 _fw-500">{{
                        Math.floor(
                          ((getStatistic.grow.viewed || 0) /
                            getStatistic.grow.total) *
                            100
                        ) > 0
                          ? $t('statistic.continue')
                          : $t('statistic.start')
                      }}</span>
                    </div>
                  </AppBtn>
                  <AppBtn
                    class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                    :btnClass="'btn_secondary'"
                    :disabled="
                      Math.floor(
                        ((getStatistic.grow.viewed || 0) /
                          getStatistic.grow.total) *
                          100
                      ) !== 100
                    "
                    @click.native="
                      showCertModal(true, {
                        title: 'HN Grow',
                        slug: 'hngrow',
                        color: 'blue',
                      })
                    "
                  >
                    <span class="_fs-16 _fw-500">{{
                      $t('modals.certificate.download')
                    }}</span>
                  </AppBtn>
                </div>
              </div>
            </div>
          </div>

          <h2
            class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600"
            v-if="false"
          >
            {{ $t('cabinet.dashboard.sections[3].title[2]') }}
          </h2>
          <div
            class="statistics__progress-all _py-6 _px-8 _px-sm-6"
            v-if="false"
          >
            <div class="progress__item">
              <Progress
                :value="
                  Math.floor(
                    ((getStatistic.webinars_new_webinars.viewed || 0) /
                      (getStatistic.webinars_new_webinars.total || 1)) *
                      100
                  )
                "
                :total="100"
                class="_mr-4"
              >
                <template v-slot:progress="props">
                  <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                    props.progress.value
                  }}</span>
                  <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                    /{{ props.progress.total }}</span
                  >
                </template>
              </Progress>
              <div class="progress__text">
                <div
                  class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                  v-html="$t('cabinet.dashboard.sections[3].title[2]')"
                ></div>
                <div class="btns-block">
                  <AppBtn
                    v-if="
                      Math.floor(
                        ((getStatistic.webinars_new_webinars.viewed || 0) /
                          (getStatistic.webinars_new_webinars.total || 1)) *
                          100
                      ) < 100
                    "
                    @click.native="
                      dataLayerPush('Общий прогресс по вебинарам', {
                        name: 'Webinars',
                        params: {
                          filtered: true,
                        },
                      })
                    "
                    class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                    :btnClass="'btn_primary'"
                  >
                    <div class="_tc-white">
                      <span class="_fs-16 _fw-500">{{
                        Math.floor(
                          ((getStatistic.webinars_new_webinars.viewed || 0) /
                            (getStatistic.webinars_new_webinars.total || 1)) *
                            100
                        ) > 0
                          ? $t('statistic.continue')
                          : $t('statistic.start')
                      }}</span>
                    </div>
                  </AppBtn>
                  <AppBtn
                    class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                    :btnClass="'btn_secondary'"
                    :disabled="
                      Math.floor(
                        ((getStatistic.webinars_new_webinars.viewed || 0) /
                          (getStatistic.webinars_new_webinars.total || 1)) *
                          100
                      ) !== 100
                    "
                    @click.native="
                      showCertModal(true, {
                        title: 'Мини-вебинары',
                        slug: 'webinars',
                        color: 'yellow',
                      })
                    "
                  >
                    <span class="_fs-16 _fw-500">{{
                      $t('modals.certificate.download')
                    }}</span>
                  </AppBtn>
                </div>
              </div>
            </div>
          </div>

          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('cabinet.dashboard.sections[3].title[3]') }}
          </h2>
          <div class="statistics__progress-all _py-6 _px-8 _px-sm-6">
            <div class="progress__item">
              <Progress
                :value="
                  Math.floor(
                    ((getStatistic.system.viewed || 0) /
                      (getStatistic.system.total || 1)) *
                      100
                  )
                "
                :total="100"
                class="_mr-4"
              >
                <template v-slot:progress="props">
                  <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                    props.progress.value
                  }}</span>
                  <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                    /{{ props.progress.total }}</span
                  >
                </template>
              </Progress>
              <div class="progress__text">
                <div
                  class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                  v-html="$t('cabinet.dashboard.sections[3].title[3]')"
                ></div>
                <div class="btns-block">
                  <AppBtn
                    v-if="
                      Math.floor(
                        ((getStatistic.system.viewed || 0) /
                          (getStatistic.system.total || 1)) *
                          100
                      ) < 100
                    "
                    @click.native="
                      dataLayerPush(
                        'Общий прогресс по Система распределения заявок',
                        {
                          name: 'System',
                          params: {
                            filtered: true,
                          },
                        }
                      )
                    "
                    class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                    :btnClass="'btn_primary'"
                  >
                    <div class="_tc-white">
                      <span class="_fs-16 _fw-500">{{
                        Math.floor(
                          ((getStatistic.system.viewed || 0) /
                            (getStatistic.system.total || 1)) *
                            100
                        ) > 0
                          ? $t('statistic.continue')
                          : $t('statistic.start')
                      }}</span>
                    </div>
                  </AppBtn>
                  <AppBtn
                    class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                    :btnClass="'btn_secondary'"
                    :disabled="
                      Math.floor(
                        ((getStatistic.system.viewed || 0) /
                          (getStatistic.system.total || 1)) *
                          100
                      ) !== 100
                    "
                    @click.native="
                      showCertModal(true, {
                        title: 'Система распределения заявок',
                        slug: 'system',
                        color: 'pink',
                      })
                    "
                  >
                    <span class="_fs-16 _fw-500">{{
                      $t('modals.certificate.download')
                    }}</span>
                  </AppBtn>
                </div>
              </div>
            </div>
          </div>

          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('cabinet.dashboard.sections[3].title[4]') }}
          </h2>
          <div class="statistics__progress-all _py-6 _px-8 _px-sm-6">
            <div class="progress__item">
              <Progress
                :value="
                  Math.floor(
                    ((getStatistic.training.viewed || 0) /
                      (getStatistic.training.total || 1)) *
                      100
                  )
                "
                :total="100"
                class="_mr-4"
              >
                <template v-slot:progress="props">
                  <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                    props.progress.value
                  }}</span>
                  <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                    /{{ props.progress.total }}</span
                  >
                </template>
              </Progress>
              <div class="progress__text">
                <div
                  class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                  v-html="$t('cabinet.dashboard.sections[3].title[4]')"
                ></div>
                <div class="btns-block">
                  <AppBtn
                    v-if="
                      Math.floor(
                        ((getStatistic.training.viewed || 0) /
                          (getStatistic.training.total || 1)) *
                          100
                      ) < 100
                    "
                    @click.native="
                      dataLayerPush(
                        'Общий прогресс по Тренинги с мероприятий',
                        {
                          name: 'Trainings',
                          params: {
                            filtered: true,
                          },
                        }
                      )
                    "
                    class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                    :btnClass="'btn_primary'"
                  >
                    <div class="_tc-white">
                      <span class="_fs-16 _fw-500">{{
                        Math.floor(
                          ((getStatistic.training.viewed || 0) /
                            (getStatistic.training.total || 1)) *
                            100
                        ) > 0
                          ? $t('statistic.continue')
                          : $t('statistic.start')
                      }}</span>
                    </div>
                  </AppBtn>
                  <AppBtn
                    class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                    :btnClass="'btn_secondary'"
                    :disabled="
                      Math.floor(
                        ((getStatistic.training.viewed || 0) /
                          (getStatistic.training.total || 1)) *
                          100
                      ) !== 100
                    "
                    @click.native="
                      showCertModal(true, {
                        title: 'Тренинги с мероприятий',
                        slug: 'trainings',
                        color: 'emerald',
                      })
                    "
                  >
                    <span class="_fs-16 _fw-500">{{
                      $t('modals.certificate.download')
                    }}</span>
                  </AppBtn>
                </div>
              </div>
            </div>
          </div>

          <h2 class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _mb-6 _mt-12 _fw-600">
            {{ $t('cabinet.dashboard.sections[3].title[5]') }}
          </h2>
          <div class="statistics__progress-all _py-6 _px-8 _px-sm-6">
            <div class="progress__item">
              <Progress
                :value="
                  Math.floor(
                    ((getStatistic.webinars_network_security.viewed || 0) /
                      (getStatistic.webinars_network_security.total || 1)) *
                      100
                  )
                "
                :total="100"
                class="_mr-4"
              >
                <template v-slot:progress="props">
                  <span class="_fs-13 _fw-700 _tc-dark-grey d-inline-block">{{
                    props.progress.value
                  }}</span>
                  <span class="_fs-13 _fw-400 _tc-dark-grey d-inline-block">
                    /{{ props.progress.total }}</span
                  >
                </template>
              </Progress>
              <div class="progress__text">
                <div
                  class="progress__title _fw-700 _fs-sm-16 _fs-20 _lh-24 _tc-dark _mb-2 _mb-md-0"
                  v-html="$t('cabinet.dashboard.sections[3].title[5]')"
                ></div>
                <div class="btns-block">
                  <AppBtn
                    v-if="
                      Math.floor(
                        ((getStatistic.webinars_network_security.viewed || 0) /
                          (getStatistic.webinars_network_security.total || 1)) *
                          100
                      ) < 100
                    "
                    @click.native="
                      dataLayerPush('Общий прогресс по Сетевая безопасность', {
                        name: 'NetworkSecurity',
                        params: {
                          filtered: true,
                        },
                      })
                    "
                    class="_py-2 _px-3 _mr-md-2 _mt-sm-2"
                    :btnClass="'btn_primary'"
                  >
                    <div class="_tc-white">
                      <span class="_fs-16 _fw-500">{{
                        Math.floor(
                          ((getStatistic.webinars_network_security.viewed ||
                            0) /
                            (getStatistic.webinars_network_security.total ||
                              1)) *
                            100
                        ) > 0
                          ? $t('statistic.continue')
                          : $t('statistic.start')
                      }}</span>
                    </div>
                  </AppBtn>
                  <AppBtn
                    class="_py-2 _px-4 _mt-2 _mt-md-0 _mt-sm-2"
                    :btnClass="'btn_secondary'"
                    :disabled="
                      Math.floor(
                        ((getStatistic.webinars_network_security.viewed || 0) /
                          (getStatistic.webinars_network_security.total || 1)) *
                          100
                      ) !== 100
                    "
                    @click.native="
                      showCertModal(true, {
                        title: 'Сетевая безопасность',
                        slug: 'network_security',
                        color: 'lapis',
                      })
                    "
                  >
                    <span class="_fs-16 _fw-500">{{
                      $t('modals.certificate.download')
                    }}</span>
                  </AppBtn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import AppBtnBreadCrumb from '@/components/UI/buttons/AppBtnBreadCrumb'
import Progress from '@/components/UI/intensives/Progress'
import AppBtn from '@/components/UI/buttons/AppBtn'
import { bus } from '@/main'
import { mapActions, mapGetters } from 'vuex'

export default {
  metaInfo() {
    return { title: this.$t('cabinet.dashboard.menu[5]') }
  },
  name: 'Statistics',
  components: {
    // AppBtnBreadCrumb,
    Progress,
    AppBtn,
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['getIntensiveTotalProgress', 'getStatistic']),
    allProgress() {
      let percent = 0
      let total = this.getIntensiveTotalProgress.length + 6

      this.getIntensiveTotalProgress.forEach(
        (el) => (percent += el.progress_percent)
      )
      percent += Math.floor(
        ((this.successAcademyProgress.all.viewed || 0) /
          (this.successAcademyProgress.all.total || 1)) *
          100
      )
      percent += Math.floor(
        ((this.getStatistic.grow.viewed || 0) /
          (this.getStatistic.grow.total || 1)) *
          100
      )
      percent += Math.floor(
        ((this.getStatistic.system.viewed || 0) /
          (this.getStatistic.system.total || 1)) *
          100
      )
      percent += Math.floor(
        ((this.getStatistic.webinars_new_webinars.viewed || 0) /
          (this.getStatistic.webinars_new_webinars.total || 1)) *
          100
      )
      percent += Math.floor(
        ((this.getStatistic.webinars_network_security.viewed || 0) /
          (this.getStatistic.webinars_network_security.total || 1)) *
          100
      )
      percent += Math.floor(
        ((this.getStatistic.training.viewed || 0) /
          (this.getStatistic.training.total || 1)) *
          100
      )
      return Math.round(percent / total)
    },
    successAcademyProgress() {
      if (this.getStatistic && Object.keys(this.getStatistic).length) {
        let obj = JSON.parse(JSON.stringify(this.getStatistic.success_academy))
        return {
          all: obj.section,
          sections: Object.fromEntries(
            Object.entries(obj).filter(([key]) => !key.includes('section'))
          ),
        }
      }
      return {}
    },
    colorScheme() {
      return {
        'social-media-intensive': 'green',
        'online-community-intensive': 'green',
        'new-realities': 'blue',
      }
    },
    certData() {
      return {
        title: this.$t('pages.success_academy.main_title'),
        color: 'emerald',
        slug: 'academy_success',
      }
    },
  },
  methods: {
    ...mapActions(['IntensivesTotalProgress', 'fetchStatistic']),
    getTranslate(item) {
      if (item && item.translates && item.translates.length) {
        return (
          item.translates.find(
            (el) => el.language === this.Trans.currentLocale
          ) || item.translates[0]
        )
      } else {
        return item
      }
    },
    dataLayerPush(title, to) {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'lk_to_learning',
          param_value: title,
        })
      }
      this.$router.push(to)
    },
    showCertModal(state, item) {
      let obj = {
        name: this.getTranslate(item).title.replace(/[<]br[^>]*[>]/gi, ' '),
        slug: item.slug,
        color: item.color || this.colorScheme[item.slug],
      }
      bus.$emit('showCertModal', state, obj)
      if (this.$gtm) {
        this.$gtm.push({
          event: 'lk_sertificat',
          param_value: this.helpers.stripHtml(this.getTranslate(item).title),
        })
      }
    },
  },
  async mounted() {
    await this.IntensivesTotalProgress()
    await this.fetchStatistic()
  },
}
</script>

<style lang="scss" scoped>
.statistics {
  @media screen and (max-width: 1220px) {
    &-main__title {
      border-bottom: 1px solid #d1d2cd;
    }
  }

  &__info {
    display: grid;
    grid-template-columns: 1fr 384px;
    column-gap: 32px;
    row-gap: 32px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
      row-gap: 32px;
      column-gap: 0;
    }
  }

  &__progress {
    border: 1px solid color('grey-second');
    border-radius: 16px;
  }

  &__progress-all {
    max-width: 384px;
    border: 1px solid color('grey-second');
    border-radius: 16px;
    @media screen and (max-width: 1220px) {
      max-width: 100%;
    }
  }

  &__info-row {
    display: grid;
    grid-template-columns: repeat(3, 384px);
    column-gap: 32px;
    row-gap: 32px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
      column-gap: 32px;
      row-gap: 32px;
    }
  }
}

.progress {
  &-all__item {
    display: grid;
    grid-template-columns: 1fr;
    .inner-container {
      display: grid;
      grid-template-columns: 72px 1fr;
      align-items: center;
    }
  }
  &__text {
    @media screen and (max-width: 1220px) {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    @media screen and (max-width: 743px) {
      flex-flow: column;
      align-items: flex-start;
    }
    .btns-block {
      display: flex;
      flex-flow: column;
      .btn_primary:first-child {
        max-width: fit-content;
        @media screen and (max-width: 1220px) {
          max-width: none;
        }
        @media screen and (max-width: 743px) {
          max-width: fit-content;
        }
      }
      @media screen and (max-width: 1220px) {
        flex-flow: row;
      }
      @media screen and (max-width: 743px) {
        flex-flow: column;
      }
    }
  }
  &__title {
    max-width: 202px;
  }
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    @media screen and (max-width: 1220px) {
      align-items: center;
    }
    @media screen and (max-width: 743px) {
      align-items: flex-start;
    }
  }
}
</style>
